import { ROLLOVER_GROUPS } from 'utils/assignmentRollover';

export const ASSIGNMENT_ROLLOVER_GROUPS = Object.freeze([
    {
        id: ROLLOVER_GROUPS.SUBMISSION_TYPES,
        translationKey: 'assignment-rollover.student-file-type-submission',
        label: 'Student File Type Submission',
    },
    { id: ROLLOVER_GROUPS.DESCRIPTION, translationKey: 'rubric.form.description-default', label: 'Description' },
    { id: ROLLOVER_GROUPS.RUBRIC, translationKey: 'rubric.title-rubric', label: 'Rubric' },
    { id: ROLLOVER_GROUPS.CITATION_FORMAT, translationKey: 'citation-format.label', label: 'Citation Format' },
    { id: ROLLOVER_GROUPS.CONTENT_BANK, translationKey: 'content-bank.title', label: 'Content Bank' },
    { id: ROLLOVER_GROUPS.GRADING, translationKey: 'grading-section.grading-settings', label: 'Grading Settings' },
    { id: ROLLOVER_GROUPS.FEEDBACK, translationKey: 'feedback-section.title', label: 'Feedback Settings' },
    {
        id: ROLLOVER_GROUPS.FORMATIVE,
        translationKey: 'formative-feedback.settings-title',
        label: 'Formative Feedback Settings',
    },
    {
        id: ROLLOVER_GROUPS.INLINE_COMMENTS,
        translationKey: 'inline-comments-section.inline-comments-settings',
        label: 'Inline Comments Settings',
    },
]);
